import template from './pdf.html';

export default angular
  .module('doxy.common.components.pdf', [])
  .directive('dPdf', function () {
    return {
      template,
      scope: {
        document: '=dDocument',
        details: '=dDetails',
        onDownload: '&dOnDownload'
      },
      restrict: 'E',
      controller: 'PdfController as pdf',
    };
  })
  .controller('PdfController', function ($scope, $injector, $timeout, Browser, $element) {
    $scope.isIPad = Browser.isIPad();
    import('vendor/pdf').then(
      ({ PDFJS, angularPdfViewerModule, workerSrc }) => {
        window.PDFJS = PDFJS;
        window.PDFJS.workerSrc = workerSrc;
        window.PDFJS.GlobalWorkerOptions.workerSrc = workerSrc;

        $injector.loadNewModules([angularPdfViewerModule]);
        $scope.pdfDelegate = function() {
          return $injector.get('pdfDelegate').$getByHandle('container');
        };

        const destroyDocumentLoadedWatcher = $scope.$watch(() => $scope.pdfDelegate().getPageCount() > 0, (loaded) => {
          if (Boolean(loaded)) {
            $scope.isDocumentLoaded = true;
            destroyDocumentLoadedWatcher();
          }
        });

        $timeout(() => {
          $scope.PDFJSLoaded = true;
        });

        function scrollTop() {
          $element[0].querySelector('.pdf-viewer-wrapper').scrollTop = 0;
        }

        $scope.onPrevClick = function() {
          $scope.pdfDelegate().prev();
          scrollTop();
        };

        $scope.onNextClick = function() {
          $scope.pdfDelegate().next();
          scrollTop();
        };

      }
    );
  })
  .directive('dPdfCurrentPage', function () {
    return {
      restrict: 'A',
      scope: {
        model: '=ngModel',
        pdfDelegate: '&dPdfDelegate',
      },
      link: function (scope) {
        scope.$watch(
          function () {
            if (!scope.pdfDelegate()) return;
            return scope.pdfDelegate().getCurrentPage();
          },
          function (newValue) {
            scope.model = newValue;
          }
        );

        scope.$watch('model', function (newValue) {
          const pdfDelegate = scope.pdfDelegate();
          const num = parseInt(newValue);
          scope.model = num;
          if (!num || !pdfDelegate || pdfDelegate.getCurrentPage() === num) {
            return;
          }

          const max = pdfDelegate.getPageCount();
          if (num < 1) {
            scope.model = 1;
          } else if (num > max) {
            scope.model = max;
          } else {
            pdfDelegate.goToPage(num);
          }
        });
      },
    };
  }).name;
